<template>
    <div>
        <b-row>
            <b-col md="6" class="my-1">
                <h3 class="text-themecolor">{{group.name}} {{$t('management.groepl')}}</h3>
            </b-col>
            <b-col md="6" class="my-1">
                <div class="pull-right">
                    <b-button size="sm" @click.stop="goTo('update')" variant="themecolor" class="mr-1">
                        <i class="fa fa-edit" aria-hidden="true"></i>  {{$t('buttons.bewerken')}}
                    </b-button>
                    <delete title="Groep" :id="group.id" namespace="core" resource="groups" />
                </div>
            </b-col>
        </b-row>
        <b-row>      
            <b-col md="12">
                <div class="card">
                    <ul class="nav nav-tabs profile-tab" role="tablist">
                        <li class="nav-item">
                            <router-link :to="{ name: 'groups:detail:permissions', params: {permissions: group.permissions} }" class="nav-link" data-toggle="tab" role="tab" aria-expanded="false">
                                    {{$t('management.rechten')}}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{ name: 'groups:detail:users', params: {users: group.users} }" class="nav-link" data-toggle="tab" role="tab" aria-expanded="false">
                                    {{$t('releases.gebruikers')}}
                            </router-link>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" role="tabpanel">
                            <!-- Tabs, lazy loading -->
                            <router-view />
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-button @click="goTo('index')" variant="secondary">{{$t('buttons.terugnaaroverzicht')}}</b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'groups-detail',
    computed: {
        ...mapGetters('core',['group']),
    },
    methods: {
        ...mapActions('core',['find','delete']),
        deleteItem(id) 
        {
            var vm = this;
            vm.delete({
                resource: 'groups',
                path: 'groups',
                id: id
            })
            .then(() => {
                vm.$swal(this.$i18n.t('delete.succesvol'), `${this.$i18n.t('delete.de')} ${vm.title.toLowerCase()} ${this.$i18n.t('delete.isverwijderd')}`, this.$i18n.t('delete.succes'));   
                vm.goTo('index');
            })
            .catch(() => {
                vm.$swal(this.$i18n.t('delete.mislukt'), `${this.$i18n.t('delete.de')} ${vm.title.toLowerCase()} ${this.$i18n.t('delete.konnietwordenverwijderd')}`, this.$i18n.t('delete.error'));
            });
        },
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `groups:${name}` });
        }       
    },
    created() {
        var vm = this;
        vm.find({
            resource: 'groups', 
            id: vm.$route.params.groupId,
            cacheResult: false
        })
        .then((data) => {
            // workaround voor NavigationDuplicated exception, https://github.com/vuejs/vue-router/issues/2430
            var vm = this;
            vm.$router.push({name:'groups:detail:permissions', params: {permissions: data.permissions}, query: { time: Date.now() } })
        });
    },
}
</script>